import React from "react";
import { Row } from "antd";

// The "this is a consolidated order, we'll reprocess all of these" confirm body,
// shown before regenerating/recalculating a consolidated order's billing.
// Shared by the Billing header and the Estimate tab's Recalculate confirm so the
// wording/layout stay in one place. `prefix` lets a caller prepend an extra line
// (e.g. the driver-settlement notice) above the standard warning.
const ConsolidatedReprocessWarning = ({ orderNumbers = [], prefix = null }) => {
  const hasOrders = (orderNumbers || []).length > 0;
  return (
    <div>
      {prefix}
      <Row>
        <h4 style={{ fontWeight: "bold" }}>
          {hasOrders
            ? "This is a consolidated order we are going to reprocess all the orders shown in below"
            : "This is a consolidated order — continuing will reprocess all the orders in this consolidation"}
        </h4>
      </Row>
      {hasOrders && (
        <Row>
          <div
            style={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginTop: "10px",
              padding: "10px",
            }}
          >
            <p style={{ maxHeight: 70, overflowY: "auto" }}>
              {orderNumbers.join(", ")}
            </p>
          </div>
        </Row>
      )}
      <Row>
        <h4
          style={{
            paddingTop: "18px",
            paddingLeft: "3px",
            fontWeight: "600",
          }}
        >
          Do you want to continue ?
        </h4>
      </Row>
    </div>
  );
};

export default ConsolidatedReprocessWarning;
